// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "795220736-dirty",
    "hash": "795220736",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "795220736-dirty",
    "semverString": null,
    "version": "2.10.14",
    "buildNumber": 1
};
/* tslint:enable */
